import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, AppDispatch } from '../../store'
import { verifyToken } from '../../store/authSlice'
import { Loading } from '../common/Loading'
import { hasRoutePermission } from '../../utils/userPermissions'

export const ProtectedRoute: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()
  const { isAuthenticated, isLoading, user } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    // Verificar token se não estiver autenticado mas tiver usuário no localStorage
    // Adicionar delay para evitar interferência durante o login
    if (!isAuthenticated && localStorage.getItem('user')) {
      const timer = setTimeout(() => {
        // Verificar se não estamos na página de login para evitar interferência
        if (window.location.pathname !== '/login') {
          dispatch(verifyToken())
        }
      }, 1000)
      
      return () => clearTimeout(timer)
    }
  }, [dispatch, isAuthenticated])

  if (isLoading) {
    return <Loading fullScreen text="Verificando autenticação..." />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Verificar permissões para a rota atual
  if (!hasRoutePermission(user, location.pathname)) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
